var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-overlay',{attrs:{"show":_vm.loading,"no-wrap":"","variant":_vm.$store.state.appConfig.layout.skin === 'dark' ? 'black' : 'white'}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.html)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }